import { useNavigate } from "react-router-dom";
import { Waves } from "lucide-react";
import { Button } from "@/components/ui/button";

// X/Twitter logo component
const XLogo = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export default function Footer() {
  const navigate = useNavigate();
  
  return (
    <footer className="lg:fixed lg:bottom-0 lg:left-0 lg:right-0 z-40 border-t border-border/20 bg-background">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
          
          {/* Left: Brand + Year */}
          <div 
            className="flex items-center gap-2 cursor-pointer group shrink-0"
            onClick={() => navigate("/")}
          >
            <div className="relative w-6 h-6 gradient-primary rounded-md flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <Waves className="w-3.5 h-3.5 text-primary-foreground" />
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-foreground leading-tight">FLOW</span>
              <span className="text-xs text-muted-foreground leading-tight">{new Date().getFullYear()} All rights reserved</span>
            </div>
          </div>

          {/* Center: Navigation Links */}
          <nav className="flex items-center gap-6 text-sm">
            <button 
              onClick={() => navigate("/airdrop-challenge")} 
              className="text-primary hover:text-primary/80 transition-colors font-medium"
            >
              🚀 Challenge
            </button>
            <button 
              onClick={() => navigate("/leaderboard")} 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Leaderboard
            </button>
            <button 
              onClick={() => navigate("/emon")} 
              className="text-primary hover:text-primary/80 transition-colors font-medium"
            >
              EMON Token
            </button>
            <button 
              onClick={() => navigate("/support")} 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Support
            </button>
            <button 
              onClick={() => navigate("/privacy")} 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </button>
            <button 
              onClick={() => navigate("/terms")} 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </button>
          </nav>

          {/* Right: X Community Button + X Icon */}
          <div className="flex items-center gap-3 shrink-0">
            <a 
              href="https://x.com/emontoken1" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Button 
                size="sm" 
                className="bg-primary hover:bg-primary/90 text-primary-foreground gap-2"
              >
                <XLogo className="w-4 h-4" />
                Community
              </Button>
            </a>
            <a 
              href="https://x.com/emontoken1" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-border/50 flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
            >
              <XLogo className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
